import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NotifierService, NotifierModule } from 'angular-notifier';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Pagination } from 'src/app/core/pagination/pagination';
import { GetCrawledDataService } from '../get-crawled-data.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/core/header/header.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { SortingService } from 'src/app/core/services/sorting.service';
import { StatusHandlerService } from 'src/app/core/services/status-handler.service';
import { FormsModule, NgModel } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CoreModule } from "src/app/core/core.module";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-get-crawled-data',
  standalone: true,
  imports: [CommonModule, FormsModule, BsDatepickerModule, CoreModule, NotifierModule, BsDropdownModule],
  templateUrl: './get-crawled-data.component.html',
  styleUrl: './get-crawled-data.component.scss',
  providers: [DatePipe]
})
export class GetCrawledDataComponent {
  @ViewChild('clientMaster')  
  public clientMaster!: NgSelectComponent;
  @ViewChild('startDateField') startDateField: NgModel | undefined;
  @ViewChild('endDateField') endDateField: NgModel | undefined; 

  //public totalPages: number | any;
  //public currentPage: number | any;
  public pagination: Pagination | any;
  public showLoader: boolean = false;
  public errorMessage: any = null;
  public crawledDataList: any = [];
  public filteredData: any = [];

  private readonly notifier: NotifierService;
  bsModalRef!: BsModalRef;
  public clientMasterOptionsList: any = [];
  public colSpan: number = 20;
  public modalRef?: BsModalRef;
  public wrapText: boolean = false;
  public columnValueList: any = null;
  public clientMasterId: any = [];
  public ProcessDate: null | string | undefined | any = null;
  //public totalRecordsForPagination: number = 0;
  public config: PerfectScrollbarConfigInterface = {};
  public isSearch: boolean = false;
  validationError: string | null = null;
  allCrawledData: any[] = [];
  pagedCrawledData: any[] = [];

  currentPage: number = 1;
  pageLength: number = 50; // default
  totalPages: number = 0;
  totalRecordsForPagination: number = 0;

  public filters = {
    urlDetailID: '',
    masterSheetID: '',
    crawledMasterDataID: '',
    client: '',
    region: '',
    country: '',
    jurisdiction: '',
    regulator: '',
    docType: '',
    industry: '',
    updateType: '',
    language: '',
    sourceURL: '',
    pdfURL: '',
    docID: '',
    docTitle: '',
    docName: '',
    docURL: '',
    summary: '',
    fillingDate: '',
    crawledOn: '',
    TranslatedPDFURL:''
  };

  selectedFilter: { [key: string]: number } = {
    urlDetailID: 1,
    masterSheetID: 1,
    crawledMasterDataID: 1,
    client: 1,
    region: 1,
    country: 1,
    jurisdiction: 1,
    regulator: 1,
    docType: 1,
    industry: 1,
    updateType: 1,
    language: 1,
    sourceURL: 1,
    pdfURL: 1,
    docID: 1,
    docTitle: 1,
    docName: 1,
    docURL: 1,
    summary: 1,
    fillingDate: 1,
    crawledOn: 1,
    TranslatedPDFURL: 1
  };

  matchFilter(itemValue: any, filterValue: string, filterType: number, selectedValues?: any[]): boolean {
    // If no filter is applied, pass everything
    if ((filterValue === null || filterValue === '') && (!selectedValues || selectedValues.length === 0)) return true;
    if (itemValue === null || itemValue === undefined) return false;

    const item = itemValue.toString().toLowerCase();
    const filter = filterValue ? filterValue.toString().toLowerCase() : '';

    // First, handle dropdown multi-select filter
    if (selectedValues && selectedValues.length > 0) {
      if (!selectedValues.includes(itemValue)) return false;
    }

    // Then, handle text input filter based on filterType
    if (filterValue && filterValue !== '') {
      switch (filterType) {
        case 1: // Is equal to
          return item === filter;
        case 2: // Is not equal to
          return item !== filter;
        case 3: // Starts with
          return item.startsWith(filter);
        case 4: // Contains
          return item.includes(filter);
        case 5: // Does not contain
          return !item.includes(filter);
        case 6: // Ends with
          return item.endsWith(filter);
        case 7: // Is null
          return itemValue === null || itemValue === '';
        case 8: // Is not null
          return itemValue !== null && itemValue !== '';
        default:
          return true;
      }
    }

    return true;
  }



  public columnDropdownFilter = [
    {
      id: 1, name: 'Is equal to', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 2, name: 'Is not equal to', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 3, name: 'Starts with', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 4, name: 'Contains', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 5, name: 'Does not contain', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 6, name: 'Ends with', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 7, name: 'Is null', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    },
    {
      id: 8, name: 'Is not null', activeURLDetailID: false, activeMasterSheetID: false, activeCrawledMasterDataID: false,
      activeClient: false, activeRegion: false, activeCountry: false, activeJurisdiction: false, activeRegulator: false,
      activeDocType: false, activeIndustry: false, activeUpdateType: false, activeLanguage: false, activeSourceURL: false,
      activePDFURL: false, activeDocID: false, activeDocTitle: false, activeDocName: false, activeDocURL: false,
      activeSummary: false, activeFillingDate: false, activeCrawledOn: false,activeTranslatedPDFURL:false
    }
  ];

  constructor(private getCrawledDataService: GetCrawledDataService,
    private errorHandler: ErrorHandlerService,
    private sortingService: SortingService,
    private configService: ConfigService,
    private notifierService: NotifierService,
    private statusService: StatusHandlerService,
    private headerService: HeaderService,
    public modalService: BsModalService,
    private datePipe: DatePipe,
    private router: Router,
    private cd: ChangeDetectorRef) {
    this.notifier = notifierService;
  }

  GetClientMasterOptions() {
    this.showLoader = true;
    this.getCrawledDataService.GetClientMasterOptions().subscribe({
      next: (data: any) => {
        this.clientMasterOptionsList = data.Data;
        if (this.clientMasterOptionsList.length > 0) {
          this.clientMasterId = this.clientMasterOptionsList[0].ClientMasterID;
        }
        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Get Crawled Data", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  NavigateToSourceUrl(ID: any, Url: any) {
    if (Url && !Url.includes('http')) {
      this.router.navigate([]).then(result => { window.open('https:/' + Url, '_blank'); });
    }
    else {
      this.router.navigate([]).then(result => { window.open(Url, '_blank'); });
    }
  }

  downloadFile(data: any, fieldName: string) {
    const content = data;
    if (content) {
      let blob: Blob;
      let url: string;
      let mimeType: string;
      let fileExtension: string;

      const isJsonString = (str: string) => {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      };

      const isXmlString = (str: string) => {
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(str, "application/xml");
        return !parsedDoc.querySelector("parsererror");
      };

      if (isJsonString(content)) {
        mimeType = 'application/json';
        fileExtension = 'json';
      } else if (isXmlString(content)) {
        mimeType = 'application/xml';
        fileExtension = 'xml';
      } else {
        console.error('Unsupported file type');
        return;
      }

      blob = new Blob([content], { type: mimeType });
      url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${fieldName}.${fileExtension}`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  }

  ngOnInit(): void {
    // this.pagination = new Pagination("CrawledMasterDataID", false, 1);
    this.pagination = new Pagination();
    this.pagination.pageLength = 50;
    this.GetClientMasterOptions();
    this.GetCrawledData(this.pagination);
    this.getDefaultSortColumn();
  }

  SortColumn(newColumn: string) {
    let pagination = this.sortingService.SortColumn(this.pagination.columnName, newColumn, this.pagination.ascending, 1, this.pagination.searchText);
    pagination.clientMasterId = this.pagination.clientMasterId;
    pagination.searchString = this.pagination.searchString;
    pagination.searchText = this.pagination.searchText;
    pagination.isDeleted = this.pagination.isDeleted = false;
    pagination.pageLength = this.pagination.pageLength;
    this.pagination = pagination;

    this.GetCrawledData(this.pagination);
  }

  Search(filterForm: any) {

    if (filterForm.invalid || this.isDateRangeInvalid()) {

      Object.keys(filterForm.controls).forEach(key => {
        filterForm.controls[key].markAsTouched();
      });

      // Explicitly mark date fields also
      this.startDateField?.control.markAsTouched();
      this.endDateField?.control.markAsTouched();

      return;
    }

    this.SearchCrawledData();
  }

  SearchCrawledData() {
    this.pagination.pageIndex = 1;
    this.isSearch = true;
    this.pagination.ProcessDate = this.datePipe.transform(this.pagination.ProcessDate, 'MM/dd/YYYY');
    this.pagination.startDate = this.datePipe.transform(this.pagination.startDate, 'MM/dd/YYYY');
    this.pagination.endDate = this.datePipe.transform(this.pagination.endDate, 'MM/dd/YYYY');
    this.GetCrawledData(this.pagination);
  }

  Reset() {
    this.isSearch = false;
    this.pagination.pageIndex = 1;
    this.pagination.pageLength = 50;
    this.pagination.searchText = "";
    this.pagination.searchString = null;
    this.pagination.URLDetailId = null;
    this.pagination.masterSheetId = null;
    const tempClientID = this.clientMasterId;
    this.clientMasterId = null;
    this.pagination.clientMasterId = null;
    this.pagination.ProcessDate = null;
    this.pagination.startDate = null;
    this.pagination.endDate = null;
    this.pagination.documentURL = null;

    this.GetCrawledData(this.pagination);
    this.clientMasterId = tempClientID;
  }

  GetCrawledDataByPageLength() {
    this.pagination.pageIndex = 1;
    this.GetCrawledData(this.pagination);
  }

  GetCrawledData(paginationdetail: any) {
    this.errorMessage = null;
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.clientMasterId;
    this.showLoader = true;

    this.getCrawledDataService.GetCrawledData(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        this.crawledDataList = data.Data.Data[0]?.CrawledDataResult_Result1 || [];
        this.applyFilters();
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Get Crawled Data", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  applyFilters() {
    this.filteredData = this.crawledDataList.filter((item: any) => {
      return (
        this.matchFilter(item.UrlDetailID, this.filters.urlDetailID, this.selectedFilter['urlDetailID']) &&
        this.matchFilter(item.MasterSheetID, this.filters.masterSheetID, this.selectedFilter['masterSheetID']) &&
        this.matchFilter(item.CrawledMasterDataID, this.filters.crawledMasterDataID, this.selectedFilter['crawledMasterDataID']) &&
        this.matchFilter(item.Client, this.filters.client, this.selectedFilter['client']) &&
        this.matchFilter(item.Region, this.filters.region, this.selectedFilter['region']) &&
        this.matchFilter(item.Country, this.filters.country, this.selectedFilter['country']) &&
        this.matchFilter(item.Jurisdiction, this.filters.jurisdiction, this.selectedFilter['jurisdiction']) &&
        this.matchFilter(item.Regulator, this.filters.regulator, this.selectedFilter['regulator']) &&
        this.matchFilter(item.DocType, this.filters.docType, this.selectedFilter['docType']) &&
        this.matchFilter(item.Industry, this.filters.industry, this.selectedFilter['industry']) &&
        this.matchFilter(item.UpdateType, this.filters.updateType, this.selectedFilter['updateType']) &&
        this.matchFilter(item.Language, this.filters.language, this.selectedFilter['language']) &&
        this.matchFilter(item.SourceURL, this.filters.sourceURL, this.selectedFilter['sourceURL']) &&
        this.matchFilter(item.PDFURL, this.filters.pdfURL, this.selectedFilter['pdfURL']) &&
        this.matchFilter(item.DocID, this.filters.docID, this.selectedFilter['docID']) &&
        this.matchFilter(item.DocTitle, this.filters.docTitle, this.selectedFilter['docTitle']) &&
        this.matchFilter(item.DocName, this.filters.docName, this.selectedFilter['docName']) &&
        this.matchFilter(item.DocURL, this.filters.docURL, this.selectedFilter['docURL']) &&
        this.matchFilter(item.Summary, this.filters.summary, this.selectedFilter['summary']) &&
        this.matchFilter(item.FillingDate, this.filters.fillingDate, this.selectedFilter['fillingDate']) &&
        this.matchFilter( this.formatCreatedDate(item.CrawledOn), this.filters.crawledOn, this.selectedFilter['crawledOn'])&&
        this.matchFilter(item.TranslatedPDFURL, this.filters.TranslatedPDFURL, this.selectedFilter['TranslatedPDFURL']));

    });

    this.sortData(this.pagination.columnName);
    this.totalRecordsForPagination = this.filteredData.length;
    this.calculatePagination();
    this.setPage(1);
  }

  formatCreatedDate(date: any): string {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US'); // gives MM/DD/YYYY
}
  applyFilterOption(column: string, index: number) {
    this.selectedFilter[column] = this.columnDropdownFilter[index].id;
    this.applyFilters();
  }

  sortData(column: string) {
    if (this.pagination.columnName === column) {
      this.pagination.ascending = !this.pagination.ascending;
    } else {
      this.pagination.columnName = column;
      this.pagination.ascending = true;
    }

    this.pagedCrawledData.sort((a: any, b: any) => {
      let comparison = 0;
      const valA = a[column] ?? '';
      const valB = b[column] ?? '';

      if (!isNaN(valA) && !isNaN(valB)) {
        comparison = Number(valA) - Number(valB);
      } else if (!isNaN(new Date(valA).getTime()) && !isNaN(new Date(valB).getTime())) {
        comparison = new Date(valA).getTime() - new Date(valB).getTime();
      } else {
        const strA = valA.toString().toUpperCase();
        const strB = valB.toString().toUpperCase();
        if (strA > strB) {
          comparison = 1;
        } else if (strA < strB) {
          comparison = -1;
        }
      }

      return this.pagination.ascending ? comparison : -comparison;
    });
  }

  isDateMatch(itemDate: Date | string, filterDate: string): boolean {
    if (!itemDate) return false;
    const itemDateString = this.formatDate(itemDate);
    return itemDateString.includes(filterDate);
  }

  formatDate(date: Date | string): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  }

  copyToClipboard(text: string): void {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.notifier.notify('info', 'Copied Successfully');
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }

  GetCrawledDataToXLS(paginationdetail: any) {
    this.showLoader = true;

    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }

    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.clientMasterId;

    this.getCrawledDataService.GetCrawledDataToXLS(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;

        // Generate date-time string
        const now = new Date();
        const formattedDateTime = `${now.getFullYear()}${(now.getMonth() + 1)
          .toString()
          .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now
            .getHours()
            .toString()
            .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
              .getSeconds()
              .toString()
              .padStart(2, '0')}`;

        const fileName = `CrawledDataList_${formattedDateTime}.xlsx`;

        if (window.navigator.msSaveOrOpenBlob) {
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: 'application/pdf' });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl, fileName);
          }
        } else {
          var exportLink = document.createElement('a');
          exportLink.href = 'data:application/pdf;base64,' + encodeURI(data);
          exportLink.download = fileName;
          document.body.appendChild(exportLink);
          exportLink.click();
          document.body.removeChild(exportLink);
        }
      },
      error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage(
          'CrawledDataErrors',
          error.status
        );
      },
    });
  }

  setPage(pageEvent: any) {
    // Defensive parsing of the incoming page value
    let pageNum: number | null = null;

    // If a number was passed directly
    if (typeof pageEvent === 'number') {
      pageNum = pageEvent;
    }

    // If an object was passed (common with custom pagination components)
    if (pageNum === null && typeof pageEvent === 'object' && pageEvent !== null) {
      // try several common property names
      if (typeof pageEvent.page === 'number') pageNum = pageEvent.page;
      else if (typeof pageEvent.pageIndex === 'number') pageNum = pageEvent.pageIndex;
      else if (typeof pageEvent.currentPage === 'number') pageNum = pageEvent.currentPage;
      // sometimes the component gives 0-based index; detect and convert if needed
    }

    // Fallback: attempt to coerce to number (handles strings like "2")
    if (pageNum === null) {
      pageNum = Number(pageEvent);
      if (isNaN(pageNum)) {
        console.warn('setPage: unable to determine page number from event:', pageEvent);
        // don't change page if we can't parse input
        return;
      }
    }

    // If your pagination is 0-based (pageIndex starting at 0), convert to 1-based:
    // If pageNum is 0 but you expect page 1 to be first page, uncomment below:
    // if (pageNum === 0) pageNum = 1;

    // Ensure pagination.pageLength is numeric
    const pageLength = Number(this.pagination?.pageLength ?? this.pageLength ?? 50);
    if (isNaN(pageLength) || pageLength <= 0) {
      console.warn('setPage: invalid pageLength, defaulting to 50. Value:', this.pagination?.pageLength);
    }
    const effectivePageLength = (!isNaN(pageLength) && pageLength > 0) ? pageLength : 50;

    this.currentPage = pageNum;

    const startIndex = (pageNum - 1) * effectivePageLength;
    const endIndex = startIndex + effectivePageLength;

    // Defensive slice boundaries
    if (!this.filteredData || !Array.isArray(this.filteredData)) {
      console.warn('setPage: filteredData is not an array', this.filteredData);
      this.pagedCrawledData = [];
      return;
    }

    this.pagedCrawledData = this.filteredData.slice(startIndex, endIndex);

    // Optional debug:
    // console.log(`setPage -> page:${pageNum}, pageLength:${effectivePageLength}, start:${startIndex}, end:${endIndex}, sliced:${this.pagedCrawledData.length}`);
  }


  GetWorkbenchByPageLength() {
    this.pagination.pageLength = Number(this.pagination.pageLength);
    this.calculatePagination();
    this.setPage(1);
  }
  calculatePagination() {
    const pageLength = Number(this.pagination.pageLength);
    this.totalPages = Math.ceil(this.totalRecordsForPagination / pageLength);
  }

  getDefaultSortColumn(): string {
    return 'UrlDetailID'; // Or whatever your default column should be
  }

  isDateRangeInvalid(): boolean {
    if (!this.pagination.startDate || !this.pagination.endDate) return false;

    const start = new Date(this.pagination.startDate);
    const end = new Date(this.pagination.endDate);

    return end < start;   // <-- this is the validation rule
  }
}
